import React from 'react';
import PropTypes from 'prop-types';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import Image from 'components/Image';
import { NFT_HERO_BACKGROUND } from 'helpers/ImageHelper';
import Style from './NFTBanner.module.scss';
import Header from './components/Header';
import Description from './components/Description';
import MyRewardsCTA from './components/MyRewardsCTA';
import Thumbnail from './components/Thumbnail';

const NFTBanner = ({
  ctaText = '',
  description = '',
  header = '',
  images = {},
  rewardUrl = '',
}) => {
  const onWholeBannerClick = () => {
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_item_title: header,
        page_action_location: 'whole banner',
      },
    });
  };

  const onCtaBannerClick = (ctaText = '') => {
    handleAnalytics({
      event: Events.BANNER_CLICKED,
      payload: {
        page_button_text: ctaText,
        page_action_location: 'cta',
      },
    });
  };

  return (
    <section className={Style.container} onClick={onWholeBannerClick}>
      <Image source={NFT_HERO_BACKGROUND} className={Style.background} />
      <div className={Style.content}>
        <Header header={header} />
        <Description description={description} />
        <MyRewardsCTA ctaText={ctaText} rewardUrl={rewardUrl} onCtaBannerClick={onCtaBannerClick} />
      </div>
      <Thumbnail image={images?.promoImage} />
    </section>
  );
};

NFTBanner.propTypes = {
  ctaText: PropTypes.string,
  description: PropTypes.string,
  header: PropTypes.string,
  images: PropTypes.shape({}),
  rewardUrl: PropTypes.string,
};

export default NFTBanner;
